



























































import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { defineComponent, computed } from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { ciRentals } from '~/icons/source/thin/rentals'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { useI18n } from '~/compositions/i18n'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import {
  emptyInstallmentsParams,
  emptyLeasingParams
} from '~/constants/search/facets'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: {
    CRadioButtonGroup
  },
  setup(props) {
    const { getters: classifiedSearchGetters } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )
    const { t } = useI18n()
    const { changeParam, changeParams } = useClassifiedSearchFacet()

    const offerTypeFacet = computed(() =>
      classifiedSearchGetters('getFacetByName')('offer_type')
    )

    const leasingOptionsFacet = computed(() =>
      classifiedSearchGetters('getFacetByName')('leasing_options')
    )

    const financeFacet = computed(() =>
      classifiedSearchGetters('getFacetByName')('finance')
    )

    const inVehiclesSearch = computed(() =>
      classifiedSearchGetters('inVehiclesSearch')
    )

    const conditionOptions = computed(() => [
      {
        value: null,
        label: t('all')
      },
      ...props.searchables.map((searchable: any) => ({
        value: searchable.v,
        label: searchable.n
      }))
    ])

    const hasLeasing = computed(() => leasingOptionsFacet.value?.visible)

    const saleOption = computed(() =>
      offerTypeFacet.value?.searchables.find(s => s.v === 'sale')
    )

    const wantedOption = computed(() =>
      offerTypeFacet.value?.searchables.find(s => s.v === 'wanted')
    )

    const rentalsOption = computed(() =>
      offerTypeFacet.value?.searchables.find(s => s.v === 'rent')
    )

    const leasingSelectedValue = computed(() => {
      const selected = financeFacet.value?.values?.selected || []
      return selected.includes('leasing')
    })

    function onConditionChange(value: string) {
      changeParam({
        name: props.urlArgNames[0],
        value
      })
    }

    function onOfferTypeChange(value: string) {
      changeParam({
        name: offerTypeFacet.value.urlArgNames[0],
        value
      })
    }

    function onLeasingChange(value: boolean) {
      changeParams([
        {
          name: 'finance',
          value: value ? 'leasing' : null
        },
        ...emptyInstallmentsParams,
        ...emptyLeasingParams
      ])
    }

    return {
      ciRentals,
      ciExternalLink,
      leasingOptionsFacet,
      conditionOptions,
      hasLeasing,
      offerTypeFacet,
      wantedOption,
      saleOption,
      rentalsOption,
      leasingSelectedValue,
      inVehiclesSearch,
      onConditionChange,
      onOfferTypeChange,
      onLeasingChange
    }
  }
})
